import moment from "moment";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import "./style.css";
import set from 'lodash/set'
import Loader from "react-loader-spinner";
import {
  userChosenPropertyId,
  userChosenPropertyAddress,
  userChosenRepairLocationId,
  userChosenRepairLocation,
  userChosenHighLevelDescription,
  userChosenSupplementaryQuestions,
  userChosenEmergencyQuestion,
  userChosenAdditionalDescription,
  userChosenCovidQuestion,
  userChosenContactDetails,
  userChosenUPRN,
  userChosenSTATUS,
  userChosenEligibilityErrorCode,
  userChosenContactPhone,
  userChosenContactName,
  userChosenRelationDetails,
  workOrderData,
  userChosenSaveExit,
  userChosenNotifyAll,
  isEditState,
  saveEmailCopyRadioValue,
  userChosenSOR,
  saveAppointmentBundle,
  woFailureCase
} from "../../ducks/redux/actions/userChoices";
import {
  Container,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import { RouteComponentProps } from "react-router-dom";
import Button from "../../Button/Button";
import ExitModalAndSave from "../Modal/ExitModalAndSave";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import {
  getHeatingHotWaterCase,
  getMaintResp,
  getRepairResp,
  workOrderRepairObject,
  getContractorName,
  getDeterminedContractorDetails,
  getContractorPayload,
} from "../../ducks/redux/actions/getAddress";
import CustomerName from "../../models/Customer/CustomerName";
import * as api from "../../api";
import {
  RepairReporterId,
  ReportContactDetails,
} from "../../models/Repair/Repair";
import { isNullOrUndefined, getDMCSorCodeReference } from "../../utils/formatting";
import { PermissionsList } from "../../models/Permissions";
import RepairJourney from "../RepairJourney";
import { hasAR1Role, hasAdminRole } from "../../utils/GetRoles/permission";
import { Helper } from "../../utils/Helper/HelperUtil";
import * as EmailValidator from 'email-validator';
import { AddressType, CasePriority, RepairPriorityCode } from "../../models/Repair/CreateRepair";
import { isUndefinedNullOrEmpty } from "../../utils/translation/helper";

const getHHRSPreferenceHeaderText = (effectivePriority: any, t: any) => {
  switch (effectivePriority) {
    case RepairPriorityCode.AWAABSLAWLOW:
      return t("CPR087_HHRSLowPriorityPreferenceHeader");
    case RepairPriorityCode.AWAABSLAWEMERGENCY:
    case RepairPriorityCode.AWAABSLAWSIGNIFICANT:
      return t("CPR086_HHRSHighMediumPriorityPreferenceHeader");
    default:
      return "";
  }
};



const shouldShowDMPreferenceSection = (
  isLoading: boolean,
  isSurveyValue: boolean,
  showDMPreferenceQuestion: boolean,
  enableHHRSPreference: boolean
) => !isLoading && ((!isSurveyValue && showDMPreferenceQuestion) || enableHHRSPreference);

const getInitialRadioValue = (customerPhone: any, radioTextProvideCustomNumber: string) => {
  if (customerPhone !== null && customerPhone !== undefined && customerPhone !== "") {
    return customerPhone[0]?.number
      ? `${customerPhone[0].number}@0`
      : radioTextProvideCustomNumber;
  }

  return radioTextProvideCustomNumber;
};

const getDMReportPreferenceTitle = (
  workOrderObject: any,
  DMReportingComplianceEffectiveDate: any,
  t: any
): React.ReactNode => {
  if (workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating === CasePriority.Low) {
    return t("DML_Report_Preference_Title");
  }

  let dmReportPreferenceTitle: string;
  if (!isUndefinedNullOrEmpty(DMReportingComplianceEffectiveDate) && moment() < moment(DMReportingComplianceEffectiveDate)) {
    dmReportPreferenceTitle = t("DM_Report_Preference_Title_PreComplianceDate").replace(
      "{complianceDate}",
      moment(DMReportingComplianceEffectiveDate).format(t("DM_Report_Preference_Title_DateFormat"))
    );
  } else {
    dmReportPreferenceTitle = t("DM_Report_Preference_Title");
  }
  return dmReportPreferenceTitle;
};

interface CustomerDetailsProps extends RouteComponentProps<any> { }
const CustomerDetails: React.FC<CustomerDetailsProps> = (props) => {
  enum RepairCauseId {
    "General Wear and Tear" = 1,
    "Vandalism or Damage" = 4,
    "Complaint" = 3,
    "Technical Inspection" = 5,
    "Disrepair" = 6,
    "Right to Improve" = 7,
    "Mutual Exchange" = 8,
    "Leaseholder Improvement Request" = 9,
    "Estate Management Survey" = 10,
    "Keysafe Installation" = 11,
    "Void Survey" = 12,
    "Damp and Mould Survey" = 13
  }

  const { t } = useTranslation();
  const customerPhone = useSelector(
    (state: any) => state?.addresses?.customerPhoneNumber
  );
  const customerDetails = useSelector(
    (state: any) => state?.addresses?.saveCustomerDetails
  );
  const priority = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.selectedRepairReasonPriorityOverride ??
      state?.dashboardReducer?.formState?.selectedRepairReasonObject[0]?.priority
  );
  const hhsrsPriorityCode = useSelector(
    (state: any) => state?.dashboardReducer?.formState?.priorityCode
  );

  const effectivePriority = hhsrsPriorityCode;



  const [inputState, setInputState] = useState<any>(t("Customer_Option"));
  const [closeExitSaveModal, setcloseExitSaveModal] = useState(false);
  const dispatch = useDispatch();
  const [reporterNameInput, setReporterNameInput] = useState("");
  let errorArray: any[] = [];
  const [errorArrayState, seterrorArrayState] = useState<string[]>([]);
  const [errorEmailCopyArrayState, seterrorEmailCopyArrayState] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [numberInput, setNumberInput] = useState("");
  const [alternateEmailValue, setalternateEmailValue] = useState("");
  const [checkRadio, setCheckRadio] = useState<boolean>(true);
  const [dmAltEmailOptionSelected, setDMAltEmailOptionSelected] = useState<boolean>(false);
  const radioTextProvideCustomNumber = t("Provide_Number");
  const [radiovalue, setRadioValue] = useState(
    getInitialRadioValue(customerPhone, radioTextProvideCustomNumber)
  );

  const [radioValueEmailCopy, setradioValueEmailCopy] = useState("");
  // New state to store selected radio label response
  const [isinputdisabled, setIsinputdisabled] = useState<boolean>(true);

  const userChosenContactDetailsBackButton = useSelector(
    (state: any) => state.userChoicesReducer.userChosenContactDetails
  );
  const userChosenContactNameBackButton = useSelector(
    (state: any) => state.userChoicesReducer.userChosenContactName
  );
  const userChosenContactPhoneBackButton = useSelector(
    (state: any) => state.userChoicesReducer.userChosenContactPhone
  );
  const userChosenRelationSelect = useSelector(
    (state: any) => state.userChoicesReducer.userChosenRelationDetails
  );

  const userChosenVulnerabilityQuestion = useSelector(
    (state: any) => state.userChoicesReducer.userChosenVulnerabilityQuestion
  );
  const userChosenVulnerabilityAdditionalInformation = useSelector(
    (state: any) =>
      state.userChoicesReducer.userChosenVulnerabilityAdditionalInformation
  );
  const userChosenVandalismQuestion = useSelector(
    (state: any) => state.userChoicesReducer.userChosenVandalismQuestion
  );
  const userChosenVandalismAdditionalInformation = useSelector(
    (state: any) =>
      state.userChoicesReducer.userChosenVandalismAdditionalInformation
  );
  const workOrderObject = useSelector(
    (state: any) => state.addresses.workOrderRepair
  );
  const selectedRepairReasonObjectValue = useSelector(
    (state: any) => state?.dashboardReducer?.formState?.selectedRepairReasonObject
  );
  const isHHSRSRepairEnabledCheck = useSelector(
    (state: any) => state?.userChoicesReducer?.isHHSRSRepairEnabled
  );

  const covidConfigValue = useSelector(
    (state: any) => state?.userChoicesReducer?.isRepairCovidAllowed
  );
  const assetDetails = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.assetByIdDataObject
  );
  const vandalismConfigValue = useSelector(
    (state: any) => state?.userChoicesReducer?.vandalismtoggleValue
  );
  const isRepairMedia = useSelector(
    (state: any) => state?.userChoicesReducer?.isRepairMediaAllowed
  );
  const isSurveyValue = useSelector(
    (state: any) => state?.userChoicesReducer?.isSurvey
  );
  const EditState = useSelector(
    (state: any) => state.userChoicesReducer?.isEditState
  );
  const userChosenSurveyReason = useSelector(
    (state: any) => state.dashboardReducer.formState?.userTypedRepairReasons
  );
  const getPermissionsData = useSelector(
    (state: any) => state?.userChoicesReducer?.userProfilePermissions
  );
  const getDMReportPreferenceValue = useSelector(
    // Will contain either email value or Correspondence text
    (state: any) => state?.userChoicesReducer?.userChosenDMReportPreferenceValue
  );
  const customerData = useSelector((state: any) => state?.userChoicesReducer?.customersData);
  const isAdditionalDMWorkOrderRequired = useSelector((state: any) => state?.userChoicesReducer?.isAdditionalDMWorkOrderRequired);
  const hideVulnerablePagePermission = Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.workoder_vulnerable_hide_permission);
  const [isAR1, setAR1] = useState(false);
  const [isAdmin, setAdmin] = useState(false);
  const hideVulnerablePage = Helper.shouldHideVulnerabilityPage({
    hasHideVulnerabilityPermission: hideVulnerablePagePermission,
    isEmergency: workOrderObject?.isEmergency,
    isHazard: selectedRepairReasonObjectValue?.[0]?.isHazard,
    isHHSRSRepairEnabled: isHHSRSRepairEnabledCheck,
  })
  const hasExistingDMCaseOrWO = useSelector((state: any) => state?.userChoicesReducer?.hasExistingDMCaseOrWO);
  const isDMReportPreferenceEnabled = useSelector((state: any) => state?.userChoicesReducer?.isDMReportPreferenceEnabled);
  const isHHRSReportPreferenceEnabled = useSelector((state: any) => state?.userChoicesReducer?.isHHRSReportPreferenceEnabled);// hhrs toggle to display preference question
  const isHHSRSAssessmentCompleted = useSelector((state: any) => state?.hazard?.isHHSRSAssessmentCompleted === true);
  const DMReportingComplianceEffectiveDate = useSelector((state: any) => state?.userChoicesReducer?.DMReportingComplianceEffectiveDate);
  const configSOR = useSelector((state: any) => state?.financialReferralReducer?.sordamp);
  const userChosenSORVal = useSelector((state: any) => state?.userChoicesReducer?.userChosenSOR);
  const hasSORToSkipCausingDMQues = getDMCSorCodeReference(configSOR, userChosenSORVal);

  const enableHHRSPreference =
    isHHSRSRepairEnabledCheck === true && isHHRSReportPreferenceEnabled && isHHSRSAssessmentCompleted;

  useEffect(() => {
    if (hasAR1Role(getPermissionsData)) {
      setAR1(true);
    }
    if (hasAdminRole(getPermissionsData)) {
      setAdmin(true);
    }

  }, [getPermissionsData]);

const DisplayHHRSPreferenceHeaderText = () => {
  return getHHRSPreferenceHeaderText(effectivePriority, t);
}



  // The input disabled state is set by settingtIsinputdisabled, which runs immediately
  // before this function in the same effect, so it is not repeated here.
  const settingUserChosenRelationDetails = () => {
    if (userChosenContactDetailsBackButton === radioTextProvideCustomNumber) {
      setRadioValue(radioTextProvideCustomNumber);
      setReporterNameInput(userChosenContactNameBackButton);
      setNumberInput(userChosenContactPhoneBackButton);
      if (userChosenRelationSelect === "Friend or family") {
        dispatch(userChosenRelationDetails("Friend or Family"));
      } else {
        dispatch(userChosenRelationDetails(userChosenRelationSelect));
      }
    }
    else if (
      !userChosenContactDetailsBackButton &&
      !userChosenContactPhoneBackButton
    ) {
      if (customerPhone?.length)
        dispatch(userChosenContactDetails(`${customerPhone[0]?.number}@0`));
      dispatch(userChosenRelationDetails(""));
    }
    else {
      dispatch(userChosenContactPhone(""));
      dispatch(userChosenContactName(""));
      dispatch(userChosenRelationDetails(""));
    }
    if (customerPhone?.length === 0) {
      setCheckRadio(false)
    }
  }
  const settingtIsinputdisabled = () => {
    if (props.history.action === "PUSH" || props.history.action === "POP" || props.history.action === "REPLACE") {
      if (userChosenContactDetailsBackButton) {
        if (userChosenContactDetailsBackButton.includes('@')) {
          setRadioValue(userChosenContactDetailsBackButton);
        }
        setIsinputdisabled(radiovalue !== radioTextProvideCustomNumber);
      }
      else {
        setIsinputdisabled(
          (checkRadio && !isNullOrUndefined(customerPhone))
            ? true
            : radiovalue !== radioTextProvideCustomNumber);

      }
    }
  }
  useEffect(() => {
    let reportPreferenceValue = getDMReportPreferenceValue;
    if (isNullOrUndefined(reportPreferenceValue)) {
      if (workOrderObject?.assessmentInformation?.communicationPreference?.preferenceType === AddressType.Email) {
        reportPreferenceValue = workOrderObject?.assessmentInformation?.communicationPreference?.addresses?.digitalAddresses[0]?.address;
        dispatch(saveEmailCopyRadioValue(reportPreferenceValue));
      }
      else if (workOrderObject?.assessmentInformation?.communicationPreference?.preferenceType === AddressType.Postal) {
        reportPreferenceValue = enableHHRSPreference && !showDMPreferenceQuestion()
          ? t("HHRSEmailText")
          : t("DMC_Correspondence_Adress");
        dispatch(saveEmailCopyRadioValue(reportPreferenceValue));
      }
    }
    window.scrollTo(0, 0);
    dispatch(woFailureCase(""));
    dispatch(saveAppointmentBundle(null));
    //if the values of preference question were selected, they should be retained, else clear out radio selections  
    setradioValueEmailCopy(reportPreferenceValue);
    const existingCustomerDigitalAddress = customerData?.addresses?.digitalAddresses
      .some((digitalAddress: any) => digitalAddress.address == reportPreferenceValue)

    const setDMAltEmailOptionAsSelected = !isUndefinedNullOrEmpty(reportPreferenceValue) && !existingCustomerDigitalAddress && reportPreferenceValue !== t("DMC_Correspondence_Adress") && reportPreferenceValue !== t("HHRSEmailText");

    if (setDMAltEmailOptionAsSelected) {
      setalternateEmailValue(reportPreferenceValue);
      setradioValueEmailCopy(t("DMC_alt_option_alert_email")); // Override email value so that radio option can be displayed correctly
      setDMAltEmailOptionSelected(true);
    } else {
      setalternateEmailValue("");
    }
    settingtIsinputdisabled();
    settingUserChosenRelationDetails();
  }, [checkRadio, customerPhone, radiovalue]);

  const updateReporterContactSelection = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (EditState === true) {
      dispatch(userChosenNotifyAll(null));
      dispatch(isEditState(false));
    }
    if (e.target.value !== radioTextProvideCustomNumber) {
      dispatch(userChosenContactPhone(""));
      dispatch(userChosenContactName(""));
      dispatch(userChosenRelationDetails(""));
      setNumberInput("");
      setReporterNameInput("");
      seterrorArrayState([]);
      errorArray = [];
      dispatch(isEditState(false));
    } else {
      errorArray = [];
      dispatch(userChosenRelationDetails("Customer"));
      setCheckRadio(false);

    }
    setRadioValue(e.target.value);
    dispatch(userChosenContactDetails(e.target.value));
    setIsinputdisabled(radiovalue === radioTextProvideCustomNumber);
  };

  // Handler to save responses when email radio button value changes
  const DMReportCustEmailRadioChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const selectedValue = e.target.value;
    setradioValueEmailCopy(selectedValue);
    seterrorEmailCopyArrayState([]);
    setalternateEmailValue("");

    if (selectedValue !== t("DMC_alt_option_alert_email")) {
      setDMAltEmailOptionSelected(false);
      dispatch(saveEmailCopyRadioValue(selectedValue));
    } else {
      setDMAltEmailOptionSelected(true);
      dispatch(saveEmailCopyRadioValue(""));
    }

  };

  const reporterNumberChangeHandler = (event: any) => {
    if (EditState === true) {
      dispatch(userChosenNotifyAll(null));
      dispatch(isEditState(false));
    }
    // if value is not blank, then test the regex
    seterrorArrayState([]);
    errorArray = [];
    if (event.target.value === "" || Helper.ValidationRegex.NumericOnly.test(event.target.value)) {
      //  @ts-ignore
      setNumberInput(event.target.value.toString().slice(0, 11));

      dispatch(userChosenContactPhone(event.target.value));
    }
  };

  const isValidEmail = (email: any) => {
    return EmailValidator.validate(email);
  }


  const isReporterNameValid = () => {
    if (!reporterNameInput || (reporterNameInput && reporterNameInput.length <= 0)) {
      errorArray.push(t("Contact_Empty"));
      seterrorArrayState(errorArray);
      return false;
    }
    if (reporterNameInput.length < 2 || reporterNameInput.length > 60) {
      errorArray.push(t("Contact_Length"));
      seterrorArrayState(errorArray);
      return false;
    }
    return true;
  };

  const isReporterPhoneValid = () => {
    const ukCountryCode = "0";
    if (!numberInput) {
      errorArray.push(t("Phone_Empty"));
      seterrorArrayState(errorArray);
      return false;
    }
    if (!numberInput.startsWith(ukCountryCode) || numberInput.length < 11) {
      errorArray.push(t("Phone_Invalid"));
      seterrorArrayState(errorArray);
      return false;
    }
    return true;
  };

  const altEmailChangeHandler = (e: any) => {
    setalternateEmailValue(e.target.value);
    seterrorEmailCopyArrayState([]);

    // Only validate if the email option is selected
    if (dmAltEmailOptionSelected && (e.target.value === "" || !isValidEmail(e.target.value))) {
      seterrorEmailCopyArrayState([t("dmc_report_preference_wrong_email_alert")]);
    }

    dispatch(saveEmailCopyRadioValue(e.target.value));
  }

  const reporterCustomDetailValidate = () => {

    if (!isUndefinedNullOrEmpty(radiovalue) && radiovalue !== radioTextProvideCustomNumber) {
      //Dont validate if valid number exists for customer in Digital
      return true;
    }

    const isNameValid = isReporterNameValid();
    const isPhoneValid = isReporterPhoneValid();

    return isNameValid && isPhoneValid;
  };

  const getBackNavigationPath = (
    isVandalismActive: boolean,
    isRepairMediaEnabled: boolean
  ) => {
    if (isVandalismActive) {
      return "/VandalismQuestion";
    }

    return isRepairMediaEnabled ? "/RepairUploadmedia" : "/RepairAdditionalDetails";
  };

  const navigateBack = (path: string, shouldReplace = false) => {
    if (shouldReplace) {
      props.history.replace(path);
      return;
    }

    props.history.push(path);
  };

  const backButtonHandler = () => {
    if (!isAR1 && !isAdmin) {
      dispatch(userChosenContactDetails(""));
      dispatch(userChosenContactPhone(""));
      dispatch(userChosenContactName(""));
      dispatch(userChosenRelationDetails(""));
    }
    dispatch(isEditState(false));
    if (isSurveyValue) {
      props.history.push("/SurveyLocation");
      return;
    }

    const isVandalismActive = assetDetails?.statuses.isInDefects === true && vandalismConfigValue === true;
    const isRepairMediaEnabled = isRepairMedia === "true";

    if (assetDetails.assetType === "Property") {
      if (hideVulnerablePage) {
        const propertyPath = getBackNavigationPath(isVandalismActive, isRepairMediaEnabled);
        const shouldUsePropertyPath = isVandalismActive || !covidConfigValue;

        if (shouldUsePropertyPath) {
          navigateBack(propertyPath, isVandalismActive);
          return;
        }

        // Vulnerability was hidden on the forward journey, so COVID was reached directly
        // from Repair Upload Media. Return to it directly instead of routing through
        // Vulnerability, which only redirected here and cleared Customer Details values.
        props.history.push("/CovidQuestion");
        return;
      }

      props.history.push("/vulnerabilityquestion");
      return;
    }

    if (priority !== "Emergency" && hideVulnerablePage !== undefined && !hideVulnerablePage) {
      props.history.push("/vulnerabilityquestion");
      return;
    }

    const fallbackPath = getBackNavigationPath(isVandalismActive, isRepairMediaEnabled);
    navigateBack(fallbackPath, isVandalismActive);
  };

  const exitButtonHandler = () => {
    dispatch(userChosenPropertyId(""));

    dispatch(userChosenPropertyAddress(""));
    dispatch(userChosenRepairLocationId(0));
    dispatch(userChosenRepairLocation(""));
    dispatch(userChosenHighLevelDescription(""));
    dispatch(userChosenSupplementaryQuestions(""));
    dispatch(userChosenEmergencyQuestion(""));
    dispatch(userChosenAdditionalDescription(""));
    dispatch(userChosenCovidQuestion(""));
    dispatch(userChosenContactDetails(""));
    dispatch(userChosenUPRN(""));
    dispatch(userChosenSOR(""));
    dispatch(getRepairResp(""));
    dispatch(getHeatingHotWaterCase(""));
    dispatch(getMaintResp(""));
    dispatch(getDeterminedContractorDetails(""));
    dispatch(getContractorName(""));
    dispatch(getContractorPayload(""));
    dispatch(userChosenSTATUS(""));
    dispatch(userChosenEligibilityErrorCode(""));
    dispatch(userChosenContactPhone(""));
    dispatch(userChosenContactName(""));
    dispatch(userChosenRelationDetails(""));
    dispatch(isEditState(false));

    props.history.push("/LandingView");
  };

  const showDMPreferenceQuestion = () =>
    !!isDMReportPreferenceEnabled && //Configs
    (
      hasSORToSkipCausingDMQues || //Currently PRODAMP only
      (
        !!workOrderObject?.isCausingDampAndMould && //Covers property logic and question is shown only to Properties
        (
          !isAdditionalDMWorkOrderRequired || //Multi DM WO feature toggle config
          (isUndefinedNullOrEmpty(workOrderObject.associatedWorkOrdersIdentifier) && !hasExistingDMCaseOrWO)
        )
      )
    );

  const getPreferenceHeaderText = (): string => {
    const headerText = (enableHHRSPreference && !showDMPreferenceQuestion())
      ? DisplayHHRSPreferenceHeaderText()
      : getDMReportPreferenceTitle(workOrderObject, DMReportingComplianceEffectiveDate, t);

    return typeof headerText === "string" ? headerText : (headerText ?? "").toString();
  };

  const shouldDisplayPreferenceSection = (): boolean => {
    const headerText = getPreferenceHeaderText();
    return (
      shouldShowDMPreferenceSection(
        isLoading,
        isSurveyValue,
        showDMPreferenceQuestion(),
        enableHHRSPreference
      ) && !isUndefinedNullOrEmpty(headerText)
    );
  };

  const saveDraftAndExit = async () => {

    setcloseExitSaveModal(true);
    seterrorArrayState([]);
    seterrorEmailCopyArrayState([]);

    const dmReportPreferenceValid = shouldDisplayPreferenceSection() ? isDMReportPreferenceDetailValid() : true;
    const reporterCustomDetailValid = reporterCustomDetailValidate();

    if (!reporterCustomDetailValid || !dmReportPreferenceValid) {
      //Dont save and exit if details arent valid
      return;
    }

    dispatch(isEditState(false));
    dispatch(userChosenSaveExit(true));

    const worksOrder = new WorksOrderRequest(workOrderObject);
    dispatch(workOrderData(worksOrder));

    setIsLoading(true);
    const isWorkOrderUpdated = await submitWorkOrderDetails();

    if (!isWorkOrderUpdated) {
      setIsLoading(false);
      return;
    }

    props.history.push(
      `/WorkOrder360View/${worksOrder.identifiers?.worksOrderIdentifier}`
    );

    setTimeout(() => {
      dispatch(userChosenSaveExit(false));
    }, 6000);
  };

  const isDMReportPreferenceDetailValid = () => {
    // If no email option is selected, show error and block continue
    if (isUndefinedNullOrEmpty(getDMReportPreferenceValue)) {
      const noSelectionAlertKey = (enableHHRSPreference && !showDMPreferenceQuestion())
        ? "hhrs_report_preference_not_selected_alert"
        : "dmc_report_preference_not_selected_alert";
      seterrorEmailCopyArrayState([t(noSelectionAlertKey)]);
      return false;
    }

    if (dmAltEmailOptionSelected && !isValidEmail(alternateEmailValue)) {
      // Only validating the custom email details
      seterrorEmailCopyArrayState([t("dmc_report_preference_wrong_email_alert")]);
      return false;
    }

    return true;
  };

  const callPageHandler = async () => {
    seterrorArrayState([]);
    seterrorEmailCopyArrayState([]);

    const dmReportPreferenceValid = shouldDisplayPreferenceSection() ? isDMReportPreferenceDetailValid() : true;
    const reporterCustomDetailValid = reporterCustomDetailValidate();

    // Only call submitWorkOrderDetails if reporterCustomDetailValidate returns true
    if (dmReportPreferenceValid && reporterCustomDetailValid) {
        setIsLoading(true);
      const isWorkOrderUpdated = await submitWorkOrderDetails();

      if (!isWorkOrderUpdated) {
        setIsLoading(false);
        return;
      }

      //Redirection to next page
      if (assetDetails.assetType !== "Property") {
        props.history.push("/BlockCommunication");
      }
      else if (isSurveyValue) {
        props.history.push("/SurveyConfirmationDetails");
      }
      else {
        props.history.push("/ConfirmationDetails");
      }
    }
  };

  const nameInputChangeHandler = (e: any) => {
    seterrorArrayState([]);
    const re = Helper.ValidationRegex.AlphabetWithSpecialChars;
    // if value is not blank, then test the regex
    if (e.target.value === "" || re.test(e.target.value)) {
      setReporterNameInput(e.target.value);
      dispatch(userChosenContactName(e.target.value));
      dispatch(userChosenRelationDetails(inputState))
    }
  };

  const settingUChosenVulnerabilityQuestion = () => {
    if (userChosenVulnerabilityQuestion !== "" && userChosenVulnerabilityQuestion !== null && userChosenVulnerabilityQuestion !== "No") {
      workOrderObject.isVulnerable = true
    }
    else {
      workOrderObject.isVulnerable = false;
    }
    if (userChosenVulnerabilityAdditionalInformation !== "") {
      workOrderObject.VulnerableResponseText = userChosenVulnerabilityAdditionalInformation;
    } else {
      workOrderObject.VulnerableResponseText = null;
    }

    if (userChosenVandalismQuestion === "Yes") {
      workOrderObject.crimeReferenceNumber = userChosenVandalismAdditionalInformation;
      workOrderObject.repairCause = "Vandalism or Damage";
      workOrderObject.repairCauseId =
        RepairCauseId[
        workOrderObject.repairCause as keyof typeof RepairCauseId
        ];
    }
    else if (isSurveyValue) {
      workOrderObject.repairCause = userChosenSurveyReason;
    }
    else if(isHHSRSAssessmentCompleted){
      workOrderObject.repairCauseId = Helper.HHSRSRepairCauseId;
      workOrderObject.repairCause =
      Helper.RepairCauseLabels[Helper.HHSRSRepairCauseId];  
    }
    else {
      workOrderObject.crimeReferenceNumber = "";
      workOrderObject.repairCause = "General Wear and Tear";
      workOrderObject.repairCauseId =
        RepairCauseId[
        workOrderObject.repairCause as keyof typeof RepairCauseId
        ];
    }
  }
  const dispatchingContactDetails = () => {
    if (radiovalue !== radioTextProvideCustomNumber) {
      const radioUpdatedValue = radiovalue.split("@");
      workOrderObject.reporterContactDetails.contactNumber = radioUpdatedValue[0];
    } else {
      workOrderObject.reporterContactDetails.contactNumber =
        numberInput.length > 0 ? numberInput : null;
      dispatch(userChosenRelationDetails(inputState));
      dispatch(userChosenContactPhone(numberInput));
      dispatch(userChosenContactName(reporterNameInput));
      dispatch(userChosenContactDetails(radioTextProvideCustomNumber));
    }
  }
  const submitWorkOrderDetails = async () => {
    try {
      workOrderObject.reporterContactDetails = new ReportContactDetails();
      dispatchingContactDetails();
      const reporterFullName = customerDetails?.person?.name.title + " " + customerDetails?.person?.name.givenName + " " + customerDetails?.person?.name.surname
      const contactPersonName = new CustomerName({
        title: null,
        givenName: radiovalue !== radioTextProvideCustomNumber ? reporterFullName : reporterNameInput,
        surname: null,
      });
      workOrderObject.reporterContactDetails.name =
        contactPersonName;

      workOrderObject.reportedById =
        RepairReporterId[inputState as keyof typeof RepairReporterId];
      workOrderObject.reportedBy = inputState;
      workOrderObject.reporterContactDetails.reporterToBeContacted = true;
       if(isHHSRSAssessmentCompleted){
          workOrderObject.repairCauseId = Helper.HHSRSRepairCauseId;
          workOrderObject.repairCause =
          Helper.RepairCauseLabels[Helper.HHSRSRepairCauseId];
      }
      settingUChosenVulnerabilityQuestion();

      // Map email and preference type for both DM and HHRS preference flows.
      if (showDMPreferenceQuestion() || enableHHRSPreference) {
        const isSelectedExistingCustomerEmail = !!customerData?.addresses?.digitalAddresses?.some(
          (digitalAddress: any) =>
            digitalAddress?.digitalAddressType === "email" &&
            digitalAddress?.address === getDMReportPreferenceValue
        );

        set(workOrderObject, 'assessmentInformation.communicationPreference.addresses', {});
        if (
          getDMReportPreferenceValue === t("DMC_Correspondence_Adress") ||
          (enableHHRSPreference && !showDMPreferenceQuestion() && getDMReportPreferenceValue === t("HHRSEmailText"))
        ) {
          workOrderObject.assessmentInformation.communicationPreference.preferenceType = AddressType.Postal;
        } else if (
          isSelectedExistingCustomerEmail ||
          (getDMReportPreferenceValue === alternateEmailValue)
        ) {
          workOrderObject.assessmentInformation.communicationPreference.preferenceType = AddressType.Email;
          if (!Array.isArray(workOrderObject.assessmentInformation.communicationPreference.addresses.digitalAddresses)) {
            workOrderObject.assessmentInformation.communicationPreference.addresses.digitalAddresses = [];
          }
          const emailObj = {
            address: getDMReportPreferenceValue,
            digitalAddressType: "email"
          };
          workOrderObject.assessmentInformation.communicationPreference.addresses.digitalAddresses.push(emailObj);
        }
      }

      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);


      const woRequestParameters = _worksOrderRequest.updateWorkOrderParameter(
        workOrderObject
      );
      await api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject.id,
        "eTag"
      );
      dispatch(workOrderRepairObject(workOrderObject));
      return true;
    } catch (e) {
      console.error(e);
      setTimeout(() => {
        props.history.push("/GenericError");
      }, 1000);
      return false;
    }
  };

  const handleChange = (e: { target: { value: any } }) => {
    setInputState(e.target.value);
    dispatch(userChosenRelationDetails(e.target.value));
  };

  let errorFieldsReporterContactArray: any[] = [];
  let errorFieldsDMContactPreferenceArray: any[] = [];
  errorArrayState?.forEach((err: any) => {
    errorFieldsReporterContactArray.push(
      <div className="error">
        <div className="w-full px-2 py-2 bg-yellow flex items-center">
          <div className="px-4 pr-8">
            <i className="fas fa-exclamation-triangle text-brick-70 w-6 h-6"></i>
          </div>
          <div className="flex items-center text-black">
            <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
              {err}
            </p>
          </div>
        </div>
      </div>
    );
  });
  errorEmailCopyArrayState?.forEach((err: any) => {
    errorFieldsDMContactPreferenceArray.push(
      <div className="error">
        <div className="w-full px-2 py-2 bg-yellow flex items-center">
          <div className="px-4 pr-8">
            <i className="fas fa-exclamation-triangle text-brick-70 w-6 h-6"></i>
          </div>
          <div className="flex items-center text-black">
            <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
              {err}
            </p>
          </div>
        </div>
      </div>
    );
  });

  return (
    <Container id="custDetails-container" role="main" className="ctn-fht">
      <div id="custDetails-back-div" className="container mx-auto mb-0 md:mb-14 lg:mb-10 px-0 xl:px-0">
        <div className="back-and-journey">
          <p id="custDetails-p" className="text-teal text-xl mt-4 mb-8">
            <button type="button" className="back-button_customer-details" data-testid="custDetailsBackBtn" onClick={backButtonHandler}><i className="fas fa-angle-left mr-2"></i>{t("back")}</button>
          </p>
          <div className=""></div>
          {<RepairJourney />}
        </div>
      </div>
      <div id="custDetails-main-div" className="container">
        <div
          id="custDetails-h1"
          className="my-4 text-purple-100 text-2xl mb-2 global-txt"
        >
          {isSurveyValue ? t("Survey.Survey_Customer_Details") : t("Customer_Details")}

        </div>
        {isLoading ? (
          <Loader
            type="ThreeDots"
            color="#00BFFF"
            height={50}
            width={50}
            timeout={5000}
          />
        ) : (
          <>
            <div
              className="ml-md-3 ml-sm-3 pl-md-5 pt-sm-0 pt-3 d-flex flex-row repair-text"
              id="options"
            >
              <RadioGroup
                id="custDetails-radiogroup"
                onChange={updateReporterContactSelection}
                value={radiovalue}
              >
                {!isNullOrUndefined(customerPhone) ? (customerPhone?.map((number: any, index: number) => {
                  return (
                    number.number && (
                      <fieldset>
                        <legend>
                          <FormControlLabel
                            id="custDetails-label1"
                            className="cust-rad global-txt"
                            key={"customerPhoneNumber_" + index}
                            control={
                              <Radio
                                id="custDetails-radio1"
                                key="checkboxPhoneNumber"
                                name="checkboxPhoneNumber"
                                data-testid="checkboxPhoneNumber"
                              />
                            }
                            label={number.number}
                            value={`${number.number}@${index}`}
                          />
                        </legend>
                      </fieldset>
                    )
                  );
                })) : null}
                <fieldset>
                  <legend>
                    <FormControlLabel
                      id="custDetails-label2"
                      className="cust-rad global-txt"
                      control={
                        <Radio
                          id="custDetails-radio2"
                          key="phoneNumberforRepair"
                          name="phoneNumberforRepair"
                          data-testid="phoneNumberforRepair"
                        />
                      }
                      label={isSurveyValue ? t("Survey.Survey_Provide_Number") : radioTextProvideCustomNumber}

                      value={radioTextProvideCustomNumber}
                    />{" "}
                  </legend>
                </fieldset>
              </RadioGroup>
            </div>

            <div id="custDetails-div1" className="row  pb-4 global-txt">
              <div
                id="custDetails-div2"
                className="col-lg-4 col-sm-12 pt-2 pt-lg-0"
              >
                <input
                  id="custDetails-text1"
                  className="inpt"
                  data-testid="inputPhoneNumber"
                  aria-label="phone number"
                  type="text"
                  disabled={isinputdisabled}
                  value={numberInput}
                  style={{ width: "100%" }}
                  placeholder={t("phone_placeholder_txt")}
                  onChange={(e) => reporterNumberChangeHandler(e)}
                />
              </div>
              <div
                id="custDetails-div3"
                className="col-lg-4 col-sm-12 pt-2 pt-lg-0"
              >
                <input
                  id="custDetails-text2"
                  className="inpt"
                  type="text"
                  aria-label="customer name"
                  data-testid="customerName"
                  disabled={isinputdisabled}
                  value={reporterNameInput}
                  placeholder="Name"
                  style={{ width: "100%" }}
                  onChange={nameInputChangeHandler}
                />
              </div>

              <div id="custDetails-div4" className="col-lg-4 col-sm-12 pt-2">
                <select
                  data-testid="inputState"
                  style={{ height: 42 }}
                  id="inputState"
                  disabled={isinputdisabled}
                  className="form-select mt-10"
                  value={userChosenRelationSelect ?? inputState}
                  onChange={handleChange}
                  aria-label="Input State"
                >
                  <option
                    id="custDetails-opt1"
                    value={t("Customer_Option") as string}
                  >
                    {t("Customer_Option")}
                  </option>
                  <option
                    id="custDetails-opt2"
                    value={t("Friend_Option") as string}
                  >
                    {t("Friend_Option")}
                  </option>
                  <option
                    id="custDetails-opt3"
                    value={t("Other_Option") as string}
                  >
                    {t("Other_Option")}
                  </option>
                </select>
              </div>
            </div>
          </>
        )}
        {errorFieldsReporterContactArray.length > 0 && (
          <div
            id="custDetails-div5"
            className="alert alert-warning error-reason mar-left global-txt error-left-padd p-0"
            role="alert"
            placeholder="alert"
          >
            {errorFieldsReporterContactArray}
          </div>
        )}
      </div>

      {/* /* Email Section Start.Will Render only if showPreferenceQuestion is true */}
      {shouldDisplayPreferenceSection() && <div id="custDetails-main-div" className="container">

        <div
          id="custDetails-h1-dmcReportPreferences"
          data-testid="dmcReportPreferences-header"
          className="my-4 text-purple-100 text-2xl mb-2 global-txt"
        >{getPreferenceHeaderText()}</div>
        <div
          className="ml-md-3 ml-sm-3 pl-md-5 pt-sm-0 pt-3 d-flex flex-row repair-text"
          id="dmcReportPreferences-options"
        >
            <RadioGroup
              id="custDetails-email"
              data-testid="custDetails-email"
              onChange={DMReportCustEmailRadioChange}
              value={radioValueEmailCopy}
            >
              {!isNullOrUndefined(customerData?.addresses?.digitalAddresses) ? (customerData?.addresses?.digitalAddresses?.map((customerEmailAddress: any, index: number) => {
                return (
                  customerEmailAddress.digitalAddressType == "email" && customerEmailAddress.address && (
                    <fieldset>
                      <legend>
                        <FormControlLabel
                          id="custDetails-label3"
                          className="cust-rad global-txt"
                          key={"customerEmailAddress_" + index}
                          control={
                            <Radio
                              id="custDetails-radio3"
                              key=""
                              name=""
                              data-testid="existingEmailAddressRadio"
                            />
                          }
                          label={`${t("DMC_option_email")} ${customerEmailAddress.address}`}
                          value={customerEmailAddress.address}
                        />
                      </legend>
                    </fieldset>
                  )
                );
              })) : null}

              <fieldset>
                <legend>
                  <FormControlLabel
                    id="custDetails-label4"
                    className="global-txt"
                    key={"customCustomerAddress"}
                    control={
                      <Radio
                        id="custDetails-radio4"
                        key=""
                        name=""
                        data-testid=""
                      />
                    }
                    label={t("DMC_alt_option_alert_email")}
                    value={t("DMC_alt_option_alert_email")}
                  />
                </legend>
              </fieldset>
              {dmAltEmailOptionSelected && <div
                id="custDetails-div6"
                className="col-lg-9 col-sm-12 pt-2 pt-lg-0 dm-alt-email-compact"
              >
                {(enableHHRSPreference && !showDMPreferenceQuestion()) && (
                  <label htmlFor="custDetails-text3" className="global-txt">{t("HHRS_Email_Label")}</label>
                )}
                <input
                  id="custDetails-text3"
                  className="inpt"
                  data-testid="userInputEmail"
                  aria-label="phone number"
                  type="email"
                  value={alternateEmailValue}
                  style={{ width: "100%" }}
                  placeholder={t("Email_Placeholder")}
                  onChange={altEmailChangeHandler}
                />
              </div>}
              <fieldset>
                <legend>
                  <FormControlLabel
                    id="custDetails-label5"
                    className="cust-rad global-txt"
                    data-testid="correspondenceRadioButton"
                    key={"correspondenceAddress"}
                    control={
                      <Radio
                        id="custDetails-radio5"
                        key=""
                        name=""
                        data-testid=""
                      />
                    }
                    label={(enableHHRSPreference && !showDMPreferenceQuestion()) ? t("HHRSEmailText") : t("DMC_Correspondence_Adress")}
                    value={(enableHHRSPreference && !showDMPreferenceQuestion()) ? t("HHRSEmailText") : t("DMC_Correspondence_Adress")}
                  />
                </legend>
              </fieldset>
            </RadioGroup>
          </div>

        {errorFieldsDMContactPreferenceArray.length > 0 && (
          <div
            id="custDetails-div7"
            className="alert alert-warning error-reason mar-left global-txt error-left-padd p-0"
            role="alert"
            placeholder="alert"
          >
            {errorFieldsDMContactPreferenceArray}
          </div>
        )}
      </div>}

      <div
        id="custDetails-main-btn"
        className="flex justify-between items-center pb-4 md:pb-8 container"
      >
        <ExitModalAndSave
          id="custDetails-exitmodal"
          exit={exitButtonHandler}
          saveDraftAndExit={saveDraftAndExit}
          closeAfterSaving={closeExitSaveModal}
        />
        <Button
          id="btn_custmerDetails"
          onClick={callPageHandler}
          className="button-class"
          disabled={isLoading}
        >
          Continue
          <i className="fas fa-angle-right relativetext-white pointer-events-none arrow"></i>
        </Button>
      </div>
    </Container>
  );

};
export default CustomerDetails;
